import React from 'react';
import { CircularProgress } from '@mui/material';
import useCurrentOrders from './currentOrders-hook';
import { ICompanyCurrentOrdersResponce } from '../../../../../../Interfaces/responseTypes';
import { CompanyOrdersNavs, CurrentOrdersContentTypes } from '../../../../../../Interfaces/componentTypes';
import CompanyOrderList from './Contents/OrderList/companyOrderList';
import CompanyOrderItem from './Contents/OrderItem/companyOrderItem';
import CustomDialog from '../../../../../../Components/Dialog/customDialog';
import NoData from '../../../../../../Components/NoData/noData';
import useLanguagesHooks from '../../../../../../Components/Languages/setLanguage-hooks';
import styles from './currentOrders.module.scss';

export interface ICurrentOrdersProps {
    company_id: number,
    orders?: ICompanyCurrentOrdersResponce,
    QR: string,
    currencySymbol: string
}

const CurrentOrders: React.FC<ICurrentOrdersProps> = (props) => {
    const { currencySymbol, company_id, } = props;
    const { t } = useLanguagesHooks();
    const {
        isLoading,
        activeNav,
        activeOrders,
        isDialogOpen,
        activeContent,
        selectedOrder,
        dialogComponent,
        hasActiveOrders,
        currenOrdersNavs,
        succeededOrdersTotal,
        onBack,
        onHandleNav,
        selectOrder,
        onCloseDialog,
        setActiveContent,
        onOpenStatusDialog,
        onOpenPrintInvoceDialog,
    } = useCurrentOrders(props)

    return (
        <div className={styles.container}>
            {
                activeContent === CurrentOrdersContentTypes.LIST
                &&

                <div className={styles.navHeader}>
                    <div className={styles.navItems}>
                        {
                            currenOrdersNavs.map((nav) => {
                                return (
                                    <div
                                        key={nav.id}
                                        className={activeNav !== nav.id ? styles.navItem : styles.navItemSelected}
                                        onClick={activeNav !== nav.id ? () => onHandleNav(nav.id) : undefined}>
                                        {nav.title}({nav.count})
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={styles.totalBox}>
                        {
                            activeNav === CompanyOrdersNavs.SUCCEEDED
                            &&
                            <>
                                <p className={styles.text}>{t('Visitor.Total')}</p>
                                <p className={styles.value}>{succeededOrdersTotal} {currencySymbol}</p>
                            </>
                        }
                    </div>
                </div>
            }
            <div className={styles.pageContent}>
                {activeContent === CurrentOrdersContentTypes.LIST && (
                    isLoading ? (
                        <div className={styles.loading}>
                            <CircularProgress sx={{ color: "#b00020" }} />
                        </div>
                    ) : hasActiveOrders ? (
                        <CompanyOrderList
                            company_id={company_id}
                            orders={activeOrders}
                            currencySymbol={currencySymbol}
                            selectOrder={selectOrder}
                            onOpenStatusDialog={onOpenStatusDialog}
                        />
                    ) : (
                        <div className={styles.noDataBox}>
                            <NoData message={t('No_Data.No_Orders')} />
                        </div>
                    )
                )}
                {
                    activeContent === CurrentOrdersContentTypes.ITEM
                    &&
                    <CompanyOrderItem
                        order={selectedOrder!}
                        onBack={onBack}
                        setContentType={setActiveContent}
                        onOpenStatusDialog={onOpenStatusDialog}
                        onOpenPrintInvoceDialog={onOpenPrintInvoceDialog}
                        currencySymbol={currencySymbol}
                    />
                }
            </div>
            <CustomDialog
                open={isDialogOpen}
                onClose={onCloseDialog}
                children={dialogComponent}
            />
        </div>
    )
}

export default CurrentOrders
